import { Component } from '@angular/core';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { TuiRoot, TuiButton, TuiLink, TuiIcon } from '@taiga-ui/core';
import { TuiTabs } from '@taiga-ui/kit';
import { AuthService } from './core/auth.service';
import { ThemeService } from './core/theme.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    TuiRoot,
    CommonModule,
    TuiTabs,
    TuiButton,
    TuiIcon
  ],
  template: `
    <tui-root>
      @if (authService.isAuthenticated()) {
        <header class="app-header">
          <div class="header-content">
            <div class="brand tui-text_h5">Learn Monitoring</div>
            
            <tui-tabs class="nav-tabs">
              <a tuiTab routerLink="/dashboard" routerLinkActive>
                <tui-icon icon="@tui.layout-dashboard" class="tui-space_right-2"></tui-icon>
                Дашборд
              </a>
              <a tuiTab routerLink="/leaderboard" routerLinkActive>
                <tui-icon icon="@tui.trophy" class="tui-space_right-2"></tui-icon>
                Рейтинг
              </a>
              @if (authService.isAdmin()) {
                <a tuiTab routerLink="/admin" routerLinkActive>
                  <tui-icon icon="@tui.settings" class="tui-space_right-2"></tui-icon>
                  Админ
                </a>
              }
            </tui-tabs>

            <div class="user-block">
              <button 
                tuiButton 
                appearance="icon" 
                size="s"
                [iconStart]="themeService.isDark() ? '@tui.sun' : '@tui.moon'"
                (click)="themeService.toggle()"
                title="Сменить тему"
              >
              </button>
              <span class="tui-text_body-m">{{ authService.user()?.fullName }}</span>
              <button 
                tuiButton 
                appearance="flat" 
                size="s"
                iconStart="@tui.log-out"
                (click)="authService.logout()"
                style="color: white !important; --tui-primary: white;"
              >
                Выход
              </button>
            </div>
          </div>
        </header>
      }
      <main class="app-content">
        <div class="tui-container">
          <router-outlet></router-outlet>
        </div>
      </main>
    </tui-root>
  `,
  styles: [`
    .app-header {
      background: var(--tui-primary); /* Primary header */
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); /* Stronger shadow */
      padding: 0 1rem;
      position: sticky;
      top: 0;
      z-index: 100;
      color: #ffffff; /* White text for header */
      transition: background-color 0.3s ease;
    }

    :host-context([tuiTheme='dark']) .app-header {
        background: var(--tui-background-neutral-1); /* Standard Taiga Surface Color */
        border-bottom: 1px solid var(--tui-border-normal);
        box-shadow: none;
    }

    .header-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 1200px;
      margin: 0 auto;
      height: 4rem;
    }
    
    .brand {
      margin: 0;
      color: #ffffff;
      font-weight: 800;
      letter-spacing: -0.5px;
      font-size: 1.25rem;
    }
    
    /* Header Navigation Tabs */
    .nav-tabs {
      border-bottom: none;
      margin-left: 2rem;
      flex: 1;
      /* Override Taiga UI text tokens to be white on dark header */
      --tui-text-primary: #ffffff;
      --tui-text-secondary: rgba(255, 255, 255, 0.7);
      --tui-text-01: #ffffff; /* Legacy fallback */
      --tui-text-02: rgba(255, 255, 255, 0.7);
      --tui-primary: #ffffff; /* Active tab indicator */
    }

    /* Force button color via specific selector just in case tokens are ignored by some browsers/versions */
    .nav-tabs button {
        color: var(--tui-text-primary) !important;
    }

    .user-block {
      display: flex;
      align-items: center;
      gap: 1rem;
      color: #ffffff;
    }
    
    .app-content {
      padding: 2rem 0;
      background: var(--tui-base-02);
      min-height: calc(100vh - 4rem);
    }
    
    .tui-container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 1rem;
    }
  `],
})
export class App {
  constructor(
    public readonly authService: AuthService,
    public readonly themeService: ThemeService
  ) { }
}
